import {HttpClient} from "../../service/httpClient/HttpClient";
import {uploadFile} from "../../service/uploaderService/UploaderService";
import {FileManagerTypes} from "../../component/fileManager/FileManager";

export class MagazineSliderService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getSliders(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-sliders`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getSliderDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `site-sliders/${id}`
            ).then(resolve).catch(reject)
        })
    }

    updateSliderInfo(id, name, writer, link, description, photoId, photoFile, enabled) {
        return new Promise((resolve, reject) => {
            if (photoFile) {
                this.uploadImageFile(
                    photoFile
                ).then(response => {
                    this.handleUpdateSlider(id, name, writer, link, description, response.id, enabled)
                        .then(resolve).catch(reject)
                }).catch(reject)
            } else
                this.handleUpdateSlider(id, name, writer, link, description, photoId, enabled)
                    .then(resolve).catch(reject)
        })
    }

    handleUpdateSlider(id, name, writer, link, description, photoId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `site-sliders/${id}`,
                {
                    title: name,
                    url: link,
                    description: description,
                    authorInformation: writer,
                    photoId: photoId,
                    enabled: enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    uploadImageFile(imageFile, handleHideLoading, setUploadPercent) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                FileManagerTypes.SLIDER_IMAGES.uploadUrl,
                setUploadPercent,
                () => {
                },
                handleHideLoading,
            ).then(resolve).catch(reject)
        })
    }


    createNewSlider(name, writer, link, description, file) {
        return new Promise((resolve, reject) => {
            this.uploadImageFile(
                file
            ).then(response => {
                this.handleCreateSlider(name, writer, link, description, response.id)
                    .then(resolve).catch(reject)
            }).catch(reject)
        })
    }

    handleCreateSlider(name, writer, link, description, fileId) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `site-sliders`,
                {
                    title: name,
                    url: link,
                    description: description,
                    authorInformation: writer,
                    photoId: fileId,
                    enabled: true
                }
            ).then(resolve).catch(reject)
        })
    }
}